import { useCallback, useEffect, useState } from "react"
import { useNavigate, useParams } from "react-router-dom"
import { useApi } from "../../../api"
import { Numeral } from "../../../components/Numeral";
import { ICargo, IProduct } from "../../../interfaces"
import { Utils } from '../../../utils';
import { DetailDescription } from "./components/Description";
import { DetailProfile } from "./components/Profile";
import { NftDetailRelatedAsset } from "./components/RelatedAsset";
import { NftDetailPurchaseModal } from "./components/PurchaseModal";
import { useTranslation } from "react-i18next";
import {
  FacebookIcon,
  FacebookShareButton,
  LineIcon,
  LineShareButton,
  TelegramIcon,
  TelegramShareButton,
  TumblrIcon,
  TumblrShareButton,
  TwitterIcon,
  TwitterShareButton,
  WhatsappIcon,
  WhatsappShareButton
} from "react-share";
import { NftDetailBidModal } from "./components/BidModal";
import moment from "moment";
import { useProjectCode } from "../../../hooks/useProjectCode";

export const ProductDetailPage = () => {
  const projectCode = useProjectCode();
  const { t } = useTranslation()
  const navigate = useNavigate();
  const api = useApi(projectCode);
  const shareIconSize = 40;
  const params = useParams()
  const [mounted, setMounted] = useState<boolean>(false);
  const [product, setProduct] = useState<IProduct | null>(null);
  // const [creatorsAssets, setCreatorsAssets] = useState<INftAsset[] | null>(null);
  const [showPurchaseModal, setPurchaseModal] = useState<boolean>(false);
  const [showBidModal, setBidModal] = useState<boolean>(false);
  const [showSharePopup, setShowSharePopup] = useState<boolean>(false);
  const [favoriteCount, setFavoriteCount] = useState<number>(0);
  const [isFavoriteNft, setFavoriteNft] = useState<boolean>(false);
  const [ethRate, setEthRate] = useState<number | null>(null);

  const fetchFavoriteCount = useCallback((nftId?: string) => {
    if (!nftId) return;
    api.getNftFavoriteCount(nftId, (cargo: ICargo) => {
      if (cargo.returnCode === '000000') {
        setFavoriteCount(cargo.info);
      }
    })
  }, [api])

  useEffect(() => {
    if (params.idProducts && mounted === false) {
      api.getProductDetail(params.idProducts, (cargo: ICargo) => {
        setProduct(cargo.info);
      })
    }
    setMounted(true);
  }, [api, mounted, params.idProducts])

  // useEffect(() => {
  //   if (creatorsAssets !== null) return;
  //   if (nftAsset !== null && creatorsAssets === null && nftAsset.creatorProfile?.referralCode) {
  //     setCreatorsAssets([])
  //     api.getNftCreatorsAssets(nftAsset.creatorProfile.referralCode, (cargo: ICargo) => {
  //       if (cargo.returnCode === '000000') {
  //         setCreatorsAssets(cargo.info);
  //       }
  //     })
  //   }
  // }, [api, nftAsset, creatorsAssets])

  const handleClose = () => {
    setPurchaseModal(false)
    setBidModal(false)
  };
  const handleShow = () => setPurchaseModal(true);
  const updateFavorite = useCallback(() => {
    if (params.nftId) {
      setFavoriteCount(favoriteCount + (isFavoriteNft ? -1 : 1))
      setFavoriteNft(!isFavoriteNft)
      api.updateFavoriteNft(params.nftId)
    }
  }, [api, favoriteCount, isFavoriteNft, params.nftId])

  useEffect(() => {
    setMounted(false);
  }, [params])

  if (product === null) {
    return null;
  }
  return (
    <>
      <div className="container d-flex flex-column flex-lg-row flex-column-reverse align-items-start pt-5">
        <div className="mx-2 mx-md-auto" style={{ flex: '3 0 0%' }}>
          <div className="lform d-none d-lg-block">
            <div className="d-flex justify-between align-items-center p-2 border-down">
              <div className="d-flex align-items-center">
                <span className="material-icons txt-20 mr-2" style={{ verticalAlign: 'text-bottom', color: '#951dfe' }}>local_mall</span>
                <a href="/" className="mr-2 text-primary">出價</a>
                {/* <img src={require("../../../assets/img/nft/Tether-USDT-icon.png")} alt="" style={{ width: '24px', height: '24px' }} /> */}
              </div>
              <div className="d-flex align-items-center text-gray-400" onClick={updateFavorite}>
                <span className="mr-2">{favoriteCount}</span>
                <span className="material-icons-outlined cursor-pointer" title="加入收藏">favorite_border</span>
              </div>
            </div>
            <div className="d-flex align-items-center" style={{ minHeight: '300px' }}>
              {product.cover && <img src={Utils().normalizeImagePath(product.cover, projectCode)} alt="" className="mx-auto" style={{ maxHeight: '100%', maxWidth: '100%' }} />}
            </div>
          </div>

          <div className="lform mt-4">
            <DetailDescription description={product.description} />
            <DetailProfile />
          </div>
          <div className="p-3"></div>
        </div>

        <div className="align-self-start px-0 px-md-3 w-100" style={{ flex: '4 0 0%' }}>
          <div className="d-flex justify-content-between align-items-center">
            <div className="text-purple-600">
              <span className="mr-2 txt-18">星河系列</span><span className="material-icons" style={{ verticalAlign: 'sub', }}>verified_user</span>
            </div>
            <div className="d-flex text-center text-gray-500">
              <div className="mr-4" onClick={updateFavorite}>
                <div className={`material-icons cursor-pointer txt-18 ${isFavoriteNft ? "text-purple-700" : ""}`} title="收藏">favorite</div>
                <div className="txt-12">{favoriteCount}</div>
              </div>
              <div className="relative" onClick={() => {
                setShowSharePopup(!showSharePopup)
              }}>
                <div className="material-icons cursor-pointer txt-18" title="分享">share</div>
                <div className="txt-12 cursor-pointer">{t('share')}</div>
                {
                  <div className={`
                    ${showSharePopup ? 'scale-x-100' : 'scale-x-0'}
                    ${showSharePopup ? 'opacity-100' : 'opacity-0'}
                    ${showSharePopup ? 'shadow' : 'shadow-none'}
                    ${showSharePopup ? 'top-11' : 'top-0'}
                    ${showSharePopup ? 'right-0' : 'right-4'}
                    duration-500
                    absolute
                    rounded-full
                    p-2
                    flex 
                    gap-x-1
                    transition-all
                    origin-right`}
                  >
                    <FacebookShareButton url={window.location.href} children={<FacebookIcon round size={shareIconSize} />} />
                    <LineShareButton url={window.location.href} children={<LineIcon round size={shareIconSize} />} />
                    <TelegramShareButton url={window.location.href} children={<TelegramIcon round size={shareIconSize} />} />
                    <TumblrShareButton url={window.location.href} children={<TumblrIcon round size={shareIconSize} />} />
                    <TwitterShareButton url={window.location.href} children={<TwitterIcon round size={shareIconSize} />} />
                    <WhatsappShareButton url={window.location.href} children={<WhatsappIcon round size={shareIconSize} />} />
                  </div>
                }
              </div>
              <div></div>
              <div></div>
            </div>
          </div>
          <div className="stitle my-3 my-sm-4">{product.name}</div>

          <div className="lform d-block d-lg-none mx-2 mx-md-auto" style={{ minHeight: '300px' }}>
            <div className="d-flex justify-between align-items-center p-2 border-down">
              <div className="d-flex align-items-center">
                <span className="material-icons txt-20 mr-2" style={{ verticalAlign: 'text-bottom', color: '#951dfe' }}>local_mall</span>
                <a href="/" className="mr-2 text-primary">出價</a>
              </div>
              <div className="d-flex align-items-center text-gray-400">
                <span className="mr-2">{favoriteCount}</span>
                <span className="material-icons-outlined cursor-pointer" title="加入收藏">favorite_border</span>
              </div>
            </div>
            <div className="d-flex align-items-center" style={{ minHeight: '300px' }}>
              {product.cover && <img src={Utils().normalizeImagePath(product.cover, projectCode)} alt="" className="mx-auto" style={{ maxHeight: '100%', maxWidth: '100%' }} />}
            </div>
          </div>

          <span className="mr-3">作者</span>
          <span className="text-purple-600 cursor-pointer" onClick={() => {
            navigate(`/web/creator/${product.creatorProfile?.memberNo}`)
          }}>{product.creatorProfile?.nickname || product.creatorProfile?.memberNo}</span>

          <div className="rform bg-gray-50 p-4 mt-3 mx-2 mx-md-auto mx-lg-0 mb-4">
            <div>
              <div className="txt-14">直購價</div>
              <div className="d-flex align-items-center my-2">
                <img src={require("../../../assets/img/nft/Tether-USDT-icon.png")} alt="" width={'22px'} />
                <span className="stitle mx-2">$<Numeral value={product.price} /></span>
                {ethRate && <span>(ETH <Numeral value={product.price / ethRate} />)</span>}
              </div>
            </div>
            <div className="d-flex flex-column flex-md-row">
              <div className="bt-buy py-2" onClick={() => {
                handleShow()
                Utils().checkKyc(projectCode)
              }}>
                <span className="material-icons mr-3" style={{ verticalAlign: 'text-bottom' }}>redeem</span>
                <span className="txt-20 weight-600">購買</span>
              </div>
            </div>
          </div>

        </div>
      </div>

      {/* <div className="container">
        <div className="bform mb-5 mx-2 mx-md-auto mx-lg-2" style={{ flex: '7 0 0%' }}>
          <NftDetailRelatedAsset creatorsAssets={creatorsAssets} />
        </div>
      </div> */}
    </>
  )
}